import Icon from 'components/Icon/Icon';

import styles from './Loader.module.scss';

const Loader = () => {
  return (
    <Icon name="loader" width={100} height={100} className={styles.loader} />
  );
};

export default Loader;
